module.exports = __webpack_public_path__ + "img/amex.83e2b6d4.svg";